module.exports = __webpack_public_path__ + "img/3-1_9b4cfcc87.png";